import { createApp } from "vue";
import './integration/cf7'
import App from "./App.vue";

(() => {
    const app = createApp(App);
    const mounted = app.mount("#formychat-widgets");
    // console.log("Formychat widgets loaded", mounted);
})();